/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from './../DashboardKPIWidgets/IEnergyManagementProps';
import { IRequestContext } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { getSymbolFromCurrency } from '../shared/Utils/Utils';

export interface UtilityTypeNumber {
  Sewer: number;
  Electricity: number;
  Water: number;
  Gas: number;
}

export interface ICommonProps {
  bearerToken?: string;
  requestContext: IRequestContext;
  utilityType?: UtilityTypeNumber;
  parentPutAxios?: IAny;
}

export interface ICommonServiceProps {
  bearerToken?: string;
  requestContext: IRequestContext;
  utilityType: UtilityTypeNumber;
}
export interface IUtilityProviders {
  utilityProviderId: string;
  utilityProviderAlias: string;
  utilityProviderName: string;
  serviceTypes: [
    {
      id: string;
      naturalKey: string;
    }
  ];
}
export interface IAccountDetails {
  accountNumber?: number | string;
  accountNumberError?: string;
  idsEnabled?: boolean;
  utilityError?: string;
  action?: IAny;
  utility: string;
}
export interface IAllConnectDetails {
  accountDetails: IAccountDetails[];
  username: string;
  usernameError: string;
  password: string;
  passwordError: string;
}

export interface IManualAccountDetails {
  map(arg0: (account: IAny) => void): unknown;
  length: number;
  ManualAccountNumber?: number | string;
  manualUtility?: string;
  consumptionUnit?: string;
  demandUnit?: string;
  currencyUnit?: string;
  meterumber?: number | string;
  meterName?: number | string;
  utilityAccountId?: null;
  meterId?: null;
  utilityMeterDetailsId?: null;
}
export interface IEditAccountDetails {
  map(arg0: (account: IAny) => void): unknown;
  length: number;
  ManualAccountNumber?: number | string;
  manualUtility?: string;
  consumptionUnit?: string;
  demandUnit?: string;
  currencyUnit?: string;
  meterumber?: number | string;
  meterName?: number | string;
  utilityAccountId?: string;
  meterId?: number | string;
  utilityMeterDetailsId?: string;
}

export interface IConnectTabProps {
  allConnectDetails: IAllConnectDetails;
  setAllConnectDetails: (allConnectDetails: IAllConnectDetails) => void;
  isSubmitted: boolean;
  validateMandatoryFields: () => void;
  changeUtility: (value: string) => void;
  utilityType: UtilityTypeNumber;
  disableButton: (value: boolean) => void;
}
export interface IProgressTab {
  closeModal: () => void;
  utilityType?: string;
  ocrManageBill?: IAny;
}

export interface IUtilityFormProps {
  allConnectDetails: IAllConnectDetails;
  setAllConnectDetails: (allConnectDetails: IAllConnectDetails) => void;
  isSubmitted: boolean;
  validateMandatoryFields: () => void;
  setAccUtility: IAny;
  accUtility: IAny;
  addUtilityTable: boolean;
  setAddUtilityTable: IAny;
  utilityTyp: string;
  manualAccountUtility: IAny;
  setManualAccountUtility: IAny;
  AccountNumcheck: IAny;
  setAccountNumcheck: IAny;
}

export interface IUtilityFormEditDetailProps {
  // allConnectDetails: IAllConnectDetails;
  // setAllConnectDetails: (allConnectDetails: IAllConnectDetails) => void;
  // validateMandatoryFields: () => void;
  isSubmitted: boolean;
  setAccUtility: IAny;
  accUtility: IAny;
  addUtilityTable: boolean;
  setAddUtilityTable: IAny;
  utilityTyp: string;
  manualAccountUtility: IAny;
  setManualAccountUtility: IAny;
  isDataAvailablebill: IAny;
  setSubmitDisabled: IAny;
  emaasContext?: IAny;
}

export const consumptionUnitOptions = [
  {
    value: 'kWh',
    text: 'Kilo watt-hour (kWh)'
  },
  {
    value: 'Wh',
    text: 'watt-hour (Wh)'
  }
];

// export const consumptionUnitOptionsForWaterandSewer = [
//   {
//     value: 'm3',
//     text: 'm3'
//   },
//   {
//     value: 'km3',
//     text: 'km3'
//   },
//   {
//     value: 'Mm3',
//     text: 'Mm3'
//   },
//   {
//     value: 'Gm3',
//     text: 'Gm3'
//   },
//   {
//     value: 'Tm3',
//     text: 'Tm3'
//   },
//   {
//     value: 'gal',
//     text: 'gal'
//   },
//   {
//     value: 'kgal',
//     text: 'kgal'
//   },
//   {
//     value: 'Mgal',
//     text: 'Mgal'
//   },
//   {
//     value: 'Ggal',
//     text: 'Ggal'
//   },
//   {
//     value: 'Tgal',
//     text: 'Tgal'
//   },
//   {
//     value: 'scf',
//     text: 'scf'
//   },
//   {
//     value: 'Mcf',
//     text: 'Mcf'
//   },
//   {
//     value: 'MMcf',
//     text: 'MMcf'
//   },
//   {
//     value: 'BCF',
//     text: 'BCF'
//   },
//   {
//     value: 'Ccf',
//     text: 'Ccf'
//   },
//   {
//     value: 'L',
//     text: 'L'
//   },
//   {
//     value: 'kL',
//     text: 'kL'
//   },
//   {
//     value: 'ML',
//     text: 'ML'
//   },
//   {
//     value: 'GL',
//     text: 'GL'
//   },
//   {
//     value: 'TL',
//     text: 'TL'
//   }
// ];

export const consumptionUnitOptionsForGas = [
  // {
  //   value: 'dth',
  //   text: 'dth'
  // },
  {
    value: 'therms',
    text: 'Therms (thm)'
  },
  // {
  //   value: 'K Dth',
  //   text: 'K Dth'
  // },
  {
    value: 'MMBtu',
    text: 'Metric Million British Thermal Unit (MMBtu)'
  },
  // {
  //   value: 'K MMBTU',
  //   text: 'K MMBTU'
  // },
  // {
  //   value: 'kJ',
  //   text: 'kJ'
  // },
  // {
  //   value: 'J',
  //   text: 'J'
  // },
  // {
  //   value: 'Ccf',
  //   text: 'Ccf'
  // },
  {
    value: 'm3',
    text: 'Cubic Metres (m3)'
  },
  {
    value: 'kWh',
    text: 'Kilo Watt-Hour (kWh)'
  },
  {
    value: 'GJ',
    text: 'giga joules (GJ)'
  },
  {
    value: 'KJ',
    text: 'kilo joules (KJ)'
  },
  {
    value: 'MJ',
    text: 'mega joules (MJ)'
  },
  {
    value: 'TJ',
    text: 'tera joules (TJ)'
  },
  {
    value: 'J',
    text: 'joules (J)'
  },
  {
    value: 'scf',
    text: 'Standard Cubic Foot (scf)'
  },
  // {
  //   value: 'km3',
  //   text: 'km3'
  // },
  // {
  //   value: 'nm3',
  //   text: 'nm3'
  // },
  // {
  //   value: 'knm3',
  //   text: 'knm3'
  // }
  {
    value: 'sm3',
    text: 'Standard Cubic Meter (sm3)'
  }
];

export const consumptionUnitOptionsForWaterSewer = [
  {
    value: 'gal',
    text: 'Gallons(US) (gal)'
  },
  {
    value: 'igal',
    text: 'Gallons(UK) (igal)'
  },
  {
    value: 'kgal',
    text: 'Thousand Gallons (US) (kgal)'
  },
  {
    value: 'kigal',
    text: 'Thousand Gallons (UK) (kigal)'
  },
  {
    value: 'mgal',
    text: 'Million Gallons (US) (Mgal)'
  },
  {
    value: 'migal',
    text: 'Million Gallons (UK) (M igal)'
  },
  {
    value: 'mmcf',
    text: 'Million cubic feet (MMcf)'
  },
  {
    value: 'kcf',
    text: 'Thousand cubic feet (kcf)'
  },
  {
    value: 'm3',
    text: 'Cubic Meters (m3)'
  },
  {
    value: 'ccf',
    text: 'Hundred Cubic Feet (Ccf)'
  },
  {
    value: 'ft3',
    text: 'Cubic Feet (ft3)'
  },
  {
    value: 'L',
    text: 'liter (L)'
  },
  {
    value: 'kL',
    text: 'Kiloliter (kL)'
  }
  // {
  //   value: 'HCF',
  //   text: 'HCF'
  // },
  // {
  //   value: 'TGAL',
  //   text: 'TGAL'
  // },
  // {
  //   value: 'KGAL',
  //   text: 'KGAL'
  // },
  // {
  //   value: 'HGAL',
  //   text: 'HGAL'
  // },
  // {
  //   value: 'KL',
  //   text: 'KL'
  // },
  // {
  //   value: 'MGD',
  //   text: 'MGD'
  // },
  // {
  //   value: 'RCHL',
  //   text: 'RCHL'
  // },
  // {
  //   value: 'TONS PER HOUR',
  //   text: 'TONS PER HOUR'
  // },
  // {
  //   value: 'MGAL',
  //   text: 'TONS PER HOUR'
  // }
];

export const demandUnitOption = [
  {
    value: 'W',
    text: 'Watt (W)'
  },
  {
    value: 'kW',
    text: 'Kilowatt (kW)'
  },
  {
    value: 'kVA',
    text: 'Kilo-Volt-Ampere (kVA)'
  },
  {
    value: 'VA',
    text: 'Volt-Ampere (VA)'
  },
  {
    value: 'kVARH',
    text: 'Kilovolt Ampere Reactive Hour (kVARH)'
  }
];

export const currencyUnitOption =
  getSymbolFromCurrency && typeof getSymbolFromCurrency === 'function'
    ? [
        {
          value: 'INR',
          text: `Indian Rupee (${getSymbolFromCurrency('INR')})`
        },
        {
          value: 'USD',
          text: `United States Dollar (${getSymbolFromCurrency('USD')})`
        },
        {
          value: 'EUR',
          text: `Euro (${getSymbolFromCurrency('EUR')})`
        },
        {
          value: 'CRC',
          text: `Costa Rican Colón (${getSymbolFromCurrency('CRC')})`
        },
        {
          value: 'GBP',
          text: `Great British Pound (${getSymbolFromCurrency('GBP')})`
        },
        {
          value: 'AUD',
          text: `Australian Dollar (${getSymbolFromCurrency('AUD')})`
        },
        {
          value: 'AED',
          text: `UAE Dirham (${getSymbolFromCurrency('AED')})`
        },
        {
          value: 'RON',
          text: `Romanian Leu (${getSymbolFromCurrency('RON')})`
        },
        {
          value: 'MYR',
          text: `Malaysian Ringgit (${getSymbolFromCurrency('MYR')})`
        },
        {
          value: 'SAR',
          text: `Saudi Riyal (${getSymbolFromCurrency('SAR')})`
        },
        {
          value: 'KRW',
          text: `South Korean Won (${getSymbolFromCurrency('KRW')})`
        },
        {
          value: 'CNY',
          text: `Chinese Yuan Renminbi (${getSymbolFromCurrency('CNY')})`
        },
        {
          value: 'PLN',
          text: `Polish złoty (${getSymbolFromCurrency('PLN')})`
        },
        {
          value: 'MXN',
          text: `Mexican Peso (${getSymbolFromCurrency('MXN')})`
        },
        {
          value: 'SGD',
          text: `Singapore Dollar (${getSymbolFromCurrency('SGD')})`
        },
        {
          value: 'HUF',
          text: `Hungarian Forint (${getSymbolFromCurrency('HUF')})`
        },
        {
          value: 'CAD',
          text: `Canadian Dollar (${getSymbolFromCurrency('CAD')})`
        },
        {
          value: 'DKK',
          text: `Danish Krone (${getSymbolFromCurrency('DKK')})`
        },
        {
          value: 'KWD',
          text: `Kuwaiti Dinar (${getSymbolFromCurrency('KWD')})`
        },
        {
          value: 'BHD',
          text: `Bahraini Dinar (${getSymbolFromCurrency('BHD')})`
        },
        {
          value: 'JOD',
          text: `Jordanian Dinar (${getSymbolFromCurrency('JOD')})`
        },
        {
          value: 'EGP',
          text: `Egyptian Pound (${getSymbolFromCurrency('EGP')})`
        },
        {
          value: 'LBP',
          text: `Lebanese Pound (${getSymbolFromCurrency('LBP')})`
        },
        {
          value: 'SDG',
          text: `Sudanese Pound (${getSymbolFromCurrency('SDG')})`
        },
        {
          value: 'OMR',
          text: `Omani Riyal (${getSymbolFromCurrency('OMR')})`
        },
        {
          value: 'QAR',
          text: `Qatari Riyal (${getSymbolFromCurrency('QAR')})`
        }
      ]
    : [];
